import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		label: {
			fontWeight: "bold"
		},
		stackedGroup: {
			marginTop: 4,
			alignItems: "flex-start",
			"& .MuiFormControlLabel-root": {
				marginLeft: 0,
			},
		},
		noteLabel: {
			fontWeight: "bold"
		}
	} satisfies Record<string, CSSObject>);
};
